import { post } from '@/utils/request'

/**
 * 淘宝授权
 * @param {String} redirect_uri 授权完毕跳回路径
 */
export function taoke_taobao_auth(redirect_uri) {
  return post('taoke_taobao_auth', { redirect_uri })
}

/**
 * 拼多多授权
 * @param {String} redirect_uri 授权完毕跳回路径
 */
export function taoke_ddk_auth(redirect_uri) {
  return post('taoke_ddk_auth', { redirect_uri })
}

/**
 * 淘宝账号授权确定更新
 * @param {object} data
 * @param {string} data.save_key - 授权后，获得的save_key
 * @param {string} data.telephone_code - 手机号验证码
 */
export function taoke_taobao_auth_save(data) {
  return post('taoke_taobao_auth_save', data)
}

/**
 * 添加京东授权链接获取
 *
 */
export function taoke_jd_auth(data) {
  return post('taoke_jd_auth', data)
}

/**
 * 添加京东授权链接获取
 *
 */
export function taoke_jd_auth_save(data) {
  return post('taoke_jd_auth_save', data, { clear: false })
}


/**
 * 发送身份短信验证码
 *
 * @param {String} telephone 登录使用手机
 * @param {captcha_r} 验证码的请求码r(使用密码登录需要) 登录使用手机
 * @param {String} telephone 登录使用手机
 */
export function auth_sms_code(data, clearToken = false) {
  return post('auth_sms_code', data, {
    clearToken,
  })
}

/**
 * 淘客CMS PID设置 不去除空字符串
 *
 * @param {String} telephone_code 手机号验证码 auth_sms_code
 * @param {String} cms_pid CMS分享使用的PID
 * @param {String} tkl_pid CMS转淘口令的PID
 * @tip 手机号验证码只有第一次需要填写（30分钟有效期），可以不传参数访问，error_code=7为需要验证码
 */
export function taoke_cms_pid_set(data) {
  return post('taoke_cms_pid_set', data, { clear: false })
}

/**
 * 淘客品库设置（品库用的PID设置） 不去除空字符串
 *
 * @param {String} telephone_code 手机号验证码 auth_sms_code
 * @param {String} wx_share_pid 微信分享用的pid（mm_xxxx_xxx_xxx）
 * @param {String} wb_share_pid 微博分享用的pid（mm_xxxx_xxx_xxx）
 * @param {String} qq_share_pid QQ分享用的pid（mm_xxxx_xxx_xxx）
 * @tip 手机号验证码只有第一次需要填写（30分钟有效期），可以不传参数访问，error_code=7为需要验证码
 */
export function taoke_pingku_pid_set(data) {
  return post('taoke_pingku_pid_set', data, { clear: false })
}

/**
 * 多多客账号授权确定更新
 * @param {object} data
 * @param {string} [data.telephone_code] - 手机号验证码 auth_sms_code
 * @param {string} data.code - 拼多多授权code
 * @param {string} data.media_id - 媒体ID
 */
export function taoke_ddk_auth_save(data) {
  return post('taoke_ddk_auth_save', data)
}
